import React, { useContext } from "react";
import AppContext from "AppContext";
import { hasElements } from "utils/arrays";
import {
    TextField,
    MenuItem,
    List,
    ListItem,
    ListItemIcon,
    Checkbox,
    ListItemText,
    Divider,
    Card,
    CardHeader,
    Grid,
} from "@material-ui/core";
import CalendarContext from "components/Calendar/CalendarContext";

function Filters() {
    const { filters, setFilters, resources, toggleCalendarAsSelected } = useContext(CalendarContext);
    const { allowedModules } = useContext(AppContext);

    function onSelectModuleChange(event) {
        const newModule = event.target && event.target.value;
        setFilters((prev) => ({ ...prev, moduleCode: newModule }));
    }

    const onFileNoChange = (event) => {
        const newFileNo = event.target && event.target.value;
        setFilters((prev) => ({ ...prev, fileNo: newFileNo }));
    };

    const onClientNameChange = (event) => {
        const newClientName = event.target && event.target.value;
        setFilters((prev) => ({ ...prev, clientName: newClientName }));
    };

    function getModuleOptions() {
        let options = [{ value: "all", label: "All modules" }];
        if (hasElements(allowedModules)) {
            options = [...options, ...allowedModules.map((m) => ({ value: m.code, label: m.name }))];
        }
        return options;
    }

    const onCalendarSelectChange = (event, calendarId) => {
        toggleCalendarAsSelected(calendarId);
    };

    return (
        <Grid container spacing={2} direction="column">
            <Grid item xs={12}>
                <Card>
                    <CardHeader title="Filters" style={{ paddingLeft: 0 }} />
                    <Divider />
                    <Grid container spacing={2} direction="column" style={{ paddingTop: "2rem" }}>
                        <Grid item xs={12}>
                            <TextField
                                select
                                variant="standard"
                                onChange={onSelectModuleChange}
                                value={filters.moduleCode || "all"}
                                fullWidth
                                size="small"
                                margin="dense"
                                label="Module"
                            >
                                {getModuleOptions().map(({ value, label }, index) => (
                                    <MenuItem key={index} value={value}>
                                        {label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="standard"
                                onChange={onFileNoChange}
                                value={filters.fileNo}
                                fullWidth
                                size="small"
                                margin="dense"
                                label="FileNo"
                                placeholder="The exact fileNo. E.g: IM1234"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="standard"
                                onChange={onClientNameChange}
                                value={filters.clientName}
                                fullWidth
                                size="small"
                                margin="dense"
                                label="Client name"
                                placeholder="The exact client full name"
                            />
                        </Grid>
                    </Grid>
                </Card>
            </Grid>

            <Grid item xs={12}>
                <Card>
                    <CardHeader title="My calendars" style={{ paddingLeft: 0 }} />
                    <Divider />
                    <List dense component="div" role="list">
                        {resources.calendars
                            ?.sort((a, b) => Boolean(b.selected) - Boolean(a.selected))
                            .filter((c) => c.accessRole === "owner")
                            .map(({ id, summary, selected, backgroundColor }) => {
                                const labelId = `transfer-list-item-${id}-label`;

                                return (
                                    <ListItem key={id} role="listitem" style={{ paddingLeft: 0 }}>
                                        <ListItemIcon>
                                            <Checkbox
                                                style={{ color: backgroundColor }}
                                                checked={selected}
                                                onChange={(event) => onCalendarSelectChange(event, id)}
                                                disableRipple
                                                inputProps={{
                                                    "aria-labelledby": labelId,
                                                }}
                                            />
                                        </ListItemIcon>
                                        <ListItemText id={labelId} primary={summary} />
                                    </ListItem>
                                );
                            })}
                    </List>
                </Card>
            </Grid>
            <Grid item xs={12}>
                <Card>
                    <CardHeader title="Other calendars" style={{ paddingLeft: 0 }} />
                    <Divider />
                    <List dense component="div" role="list">
                        {resources.calendars
                            ?.sort((a, b) => Boolean(b.selected) - Boolean(a.selected))
                            .filter((c) => c.accessRole !== "owner")
                            .map(({ id, summary, selected, backgroundColor }) => {
                                const labelId = `transfer-list-item-${id}-label`;

                                return (
                                    <ListItem key={id} role="listitem" style={{ paddingLeft: 0 }}>
                                        <ListItemIcon>
                                            <Checkbox
                                                style={{ color: backgroundColor }}
                                                checked={selected}
                                                onChange={(event) => onCalendarSelectChange(event, id)}
                                                disableRipple
                                                inputProps={{
                                                    "aria-labelledby": labelId,
                                                }}
                                            />
                                        </ListItemIcon>
                                        <ListItemText id={labelId} primary={summary} />
                                    </ListItem>
                                );
                            })}
                    </List>
                </Card>
            </Grid>
        </Grid>
    );
}

export default Filters;
